import { OWObject } from "./OWObject";
/**
* Handler pro vytvoreni proxy tridy z OWObjectu na ktere pujdou pouzivat atributy jako property
*/
export const OWObjectProxyHandler: ProxyHandler<OWObject> = {
    get: function(target: OWObject, property: PropertyKey) {
        if (typeof property === "string")
            return target.getValue(property);
        else
            return null;
    },
    set: function(target: OWObject, property: PropertyKey, value: any) {
        if (typeof property === "string") {
            target.setValue(property, value);
            return true;
        }
        return false;
    },
};
